






import { Component, Prop, Vue } from 'vue-property-decorator';
import ColorHelper, { ColorsInterface } from '../services/ColorHelper';

@Component
export default class VLetterIcon extends Vue {
  @Prop() readonly color? : string|number;
  @Prop() readonly colors? : ColorsInterface;

  created() {
    if (this.colors !== undefined) {
      ColorHelper.colors = this.colors;
    }
  }

  letter(): string {
    const value = this.$slots.default && this.$slots.default.length ? this.$slots.default[0].text : '';

    if (value) {
      return value.charAt(0).toUpperCase();
    } else {
      return '';
    }
  }

  get style() {
    let color = '';

    if (this.color) {
      color = typeof this.color === 'string' ? this.color : ColorHelper.colorAtIndex(this.color as number);
    } else {
      color = ColorHelper.random();
    }

    return {
      backgroundColor: color || ''
    };
  }
}
